





























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import GiftPackage from '@/store/entities/gift-package';
import dayjs from "dayjs";

@Component
export default class EditGiftPackage extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  giftPackage: GiftPackage = new GiftPackage();


  get loading() {
    return this.$store.state.giftPackage.loading;
  }
 

  save() {
    (this.$refs.giftPackageForm as any).validate(async (valid: boolean) => {
      if (valid) {
     
        await this.$store.dispatch({
          type: 'giftPackage/update',
          data: this.giftPackage
        });
        (this.$refs.giftPackageForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.giftPackageForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.giftPackage = Util.extend(true, {}, this.$store.state.giftPackage.editGiftPackage);
    }
  }

  giftPackageRule = {
    packageName: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('packageName')), trigger: 'blur'}],
    packageCode: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('DisplayName')),
      trigger: 'blur'
    }]
  }
}
